import styled from '@emotion/styled'
import { css } from '@emotion/core'
import { color, padding } from 'stylist'

const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  background: ${color('offWhite')};
  transition: transform 0.15s;
  height: 6rem;

  ${padding('xs')};

  ${({ showInput }) =>
    !showInput &&
    css`
      opacity: 0;
      position: absolute;
      transform: rotateX(180deg);
      z-index: -1;
    `};
`

export default InputContainer



// WEBPACK FOOTER //
// ./src/routes/home/components/InputContainer.js